import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { components } from "../../../api/generated/survey-svc";

type CustomerDownload = components["schemas"]["AdminExport"];

const initialState = {
  loading: false,
  data: {
    url: "",
  },
};

const dataSlice = createSlice({
  name: "Customer/download",
  initialState: initialState,
  reducers: {
    iniDownloadCustomersStore: () => {
      return { ...initialState };
    },
    startDownloadCustomers: (state) => {
      state.loading = true;
    },
    sucessDownloadCustomers: (
      state,
      action: PayloadAction<CustomerDownload>,
    ) => {
      state.data = action.payload;
      state.loading = false;
    },
    failDownloadCustomers: (state) => {
      state.loading = false;
    },
  },
});

export const {
  iniDownloadCustomersStore,
  failDownloadCustomers,
  startDownloadCustomers,
  sucessDownloadCustomers,
} = dataSlice.actions;

export default dataSlice.reducer;
